import data from "../data/uploadIcons.json"
import mime from "mime";

export const getIcon = (extension) => {
    if (extension && extension.substring(0, 1) === '.') extension = extension.substring(1);
    const mimeType = mime.getType(extension)
    return data.icons[data.formats[extension] ? data.formats[extension] : data.formats[mimeType]];
}